<template>
    <div class="main coach-entry">
        <div class="coach-entry__step bcw">
            <van-steps :active="step">
                <van-step>基础信息</van-step>
                <van-step>线下面试</van-step>
                <van-step>完成认证</van-step>
            </van-steps>
        </div>
        <form v-if="step == 0" @submit.prevent="checkForm" v-cloak>
            <h2 class="c6 fs2">基本信息</h2>
            <van-cell-group class="clear">
                <van-field
                    label="姓名"
                    v-model="coach.realName"
                    placeholder="请输入真实姓名"
                    required/>
                <div class="clear fs2 coach-entry__checkbox">
                    <h2 class="left">性别</h2>
                    <van-radio-group class="coach-entry__checkbox-row" v-model="coach.sex">
                        <van-radio name="1">我是男生</van-radio>
                        <van-radio name="2">我是女生</van-radio>
                    </van-radio-group>
                </div>
                <van-field
                    required
                    v-model="coach.mobile"
                    label="手机号"
                    placeholder="请输入手机号" />
                <van-cell
                    title="生日"
                    v-model="tips.birthday"
                    is-link
                    @click="timePopupShow = true; timeField = 'birthday'"
                    required/>
                <van-cell
                    title="所在城市"
                    v-model="coachAreaTips"
                    @click="areaPopupShow = true"
                    is-link
                    required />
                <van-field
                    required
                    v-model="coach.university"
                    label="毕业院校"
                    placeholder="请输入毕业院校" />
            </van-cell-group>
            <h2 class="c6 fs2">证件信息</h2>
            <van-cell-group class="clear">
                <van-field
                    required
                    label="身份证号"
                    v-model="coach.idcard"
                    placeholder="请输入身份证号" />
                <p class="coach-entry__description c9 fs2 ptm pbm">
                    1.身份证照片不得有遮挡，保证字迹清晰；<br>
                    2.请在白色背景下拍摄，保证证件边缘清晰；<br>
                    3.请从证件的正上方拍摄，防止画面变形
                </p>

                <van-row class="tac">
                    <van-col span="12">
                        <upload-file
                            :id="'idcardFrontImg'"
                            @callBackImgUrl="getIdCardUrl"></upload-file>
                        <div class="mtm mbw fs1 c9">上传身份证正面照</div>
                    </van-col>
                    <van-col span="12">
                        <upload-file
                        :id="'idcardReverseImg'"
                        @callBackImgUrl="getIdCardUrl"></upload-file>
                        <div class="mtm mbw fs1 c9">上传身份证反面照</div>
                    </van-col>
                </van-row>
            </van-cell-group>
            <h2 class="c6 fs2">从业信息</h2>
            <van-cell-group class="clear">
                <van-field
                    required
                    label="曾任职场馆"
                    v-model="coach.workedVenue"
                    placeholder="请输入，若没有请填无" />
                <van-cell
                    title="入行时间"
                    v-model="tips.entryTime"
                    @click="timePopupShow = true; timeField = 'entryTime'"
                    is-link
                    required />
                <div class="clear fs2 coach-entry__checkbox">
                    <h2 class="left">擅长课程</h2>
                    <van-checkbox-group class="coach-entry__checkbox-row" v-model="tmp.goodAtCourses">
                      <van-checkbox
                        v-for="(item, index) in coursesType"
                        :key="index"
                        :name="item"
                      >{{ item }}
                      </van-checkbox>
                    </van-checkbox-group>
                </div>
                <h2 class="fs2">资格证书</h2>
                <p class="coach-entry__description c9 fs2 pbm">
                最多上传30个图片，图片控制在10m以内
                </p>

                <van-row class="tac">
                    <van-col span="12" v-for="(item,index) in tmpbase64.qualificationImgs" :key="index">
                        <div class="upload-img__box van-uploader uploaded__box mbm">
                            <img :src="item">
                            <a @click="removeImg('qualificationImgs',index)" class="uploaded__box--del fs3">删除</a>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <upload-file
                            :id="'qualificationImgs'"
                            :mod="'continuing'"
                            @callBackImgUrl="getUploadedUrl"></upload-file>
                        <div class="mtm mbw fs1 c9">添加证书</div>
                    </van-col>
                </van-row>
            </van-cell-group>
            <!-- 选择城市弹出层 -->
            <van-popup v-model="areaPopupShow" position="bottom">
                <van-area
                    @cancel="areaPopupShow = false"
                    @confirm="getArea"
                    :area-list="arealist"/>
            </van-popup>
            <!-- 选择时间弹出层 -->
            <van-popup v-model="timePopupShow" position="bottom">
                <van-datetime-picker
                    type="date"
                    :min-date="tmp.mindate"
                    :max-date="tmp.maxdate"
                    v-model="currentDate"
                    @cancel="timePopupShow = false;timeField = ''"
                    @confirm="getTime"/>
            </van-popup>
            <the-btnbar></the-btnbar>
        </form>
        <div v-if="step == 1" class="bind_result_page">
            <div class="success-content">
                <div class="success-content_icon"><i class="iconfont green">&#xe6df;</i></div>                
                <div class="fs5 green">申请成功</div>
                <div class="success-content_tips c6 fs2">
                    <div>两个工作日内，我们工作人员会与您联系</div>
                    <div>请保持手机畅通，关注微信号，及时获取消息</div>
                </div>
                <div class="success-content_qrcode">
                    <img src="@/assets/imgs/leerweima.png" alt="">
                </div>
                <van-button class="mtm sureBtn" type="primary" size="large" @click="closePage">确定</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import router from '@/router';
import { Step, Steps,Field,Uploader,Row, Col,Popup,Area,Toast,Cell, CellGroup,DatetimePicker,RadioGroup, Radio,Checkbox, CheckboxGroup,Icon } from 'vant';
import UploadFile from '@/components/UploadFile';
import TheBtnbar from '@/components/TheBtnBar';
import AreaList from '@/assets/scripts/area';
Vue.use(Step).use(Steps).use(Field).use(Uploader).use(Icon)
Vue.use(Row).use(Col)
Vue.use(Popup).use(Area).use(Toast)
Vue.use(Cell).use(CellGroup)
Vue.use(DatetimePicker)
Vue.use(Radio).use(RadioGroup)
Vue.use(Checkbox).use(CheckboxGroup)
export default {
    name: 'CoachEntry',
    components:{
        UploadFile,TheBtnbar
    },
    data(){
        return {
            step: null,    // 入驻步骤
            coach: {
                realName: '',  // 真实姓名
                sex: '',   // 性别
                mobile: '',    // 联系电话
                birthday: '',    // 生日
                province: '',   // 省编码
                city: '',   // 市编码
                county: '', //  区编码
                university: '',    // 毕业院校

                idcard: '',     // 身份证号
                idcardFrontImg: '', // 身份证正面照片
                idcardReverseImg: '',   // 身份证背面照片

                workedVenue: '',   // 曾任场馆
                entryTime: '',  // 入行时间
                goodAtCourses: '',   // 擅长课程
                qualificationImgs: '',    // 资格证书
            },
            coachAreaTips:'请选择',
            arealist:AreaList,
            areaPopupShow: false,

            tips:{
                birthday:'请选择',    // 生日文本
                entryTime:'请选择',   // 入行时间文本
            },
            tmp: {
                goodAtCourses: [],  // 用户选择的擅长课程
                qualificationImgs: [],     // 用户上传的证书
                mindate: new Date(1949,9,1),    // 最小预设时间
                maxdate: new Date(),    // 最大预设时间
            },
            tmpbase64: {
                qualificationImgs: [],     // 用户上传的证书防止跨域不显示的副本
            },
            currentDate: new Date(),
            timePopupShow: false,
            timeField: '',
            coursesType:['中八', '斯诺克'],  // 候选擅长课程

        }
    },
    created() {
        let _this = this;
        // 获取当前用户的申请信息
        this.$http.post('club_coach/getCoachBaseInfo').then(function(res){
            if(res.data.value){
                if(res.data.value.status == 'applying'){
                  // 申请中
                    _this.step = 1;
                }else if(res.data.value.status == 'passed'){
                  // 已通过
                    _this.step = 2;
                }else{
                    _this.step=0;
                }
            }
        })
    },
    methods: {
        checkForm: function(){
          // 表单验证
            if(!this.coach.realName){
                Toast.fail('真实姓名必填'); return false;
            }
            if(!this.coach.sex){
                Toast.fail('性别必选'); return false;
            }
            if(!this.coach.mobile){
                Toast.fail('手机号必填'); return false;
            }
            if(!this.coach.birthday){
                Toast.fail('生日必填'); return false;
            }
            if(!this.coach.province || !this.coach.city || !this.coach.county){
                Toast.fail('请选择所在城市'); return false;
            }
            if(!this.coach.university){
                Toast.fail('毕业院校必填'); return false;
            }
            if(!this.coach.idcard || !this.coach.idcardFrontImg || !this.coach.idcardReverseImg){
                Toast.fail('身份证号和身份证照片不能为空'); return false;
            }
            if(!this.coach.workedVenue){
                Toast.fail('曾任场馆必填，若没有请填无'); return false;
            }
            if(!this.coach.entryTime){
                Toast.fail('入行时间必填'); return false;
            }
            if(!this.tmp.goodAtCourses){
                Toast.fail('擅长课程必填'); return false;
            }else{
                this.coach.goodAtCourses = JSON.stringify(this.tmp.goodAtCourses)
            }
            if(!this.tmp.qualificationImgs){
                Toast.fail('资格证书必填'); return false;
            }else{
                // console.log(this.tmp.qualificationImgs)
                this.coach.qualificationImgs = JSON.stringify(this.tmp.qualificationImgs)
            }
            /*console.log(this.coach)
            return false;*/
            let _this = this;
            // 提交表单
            this.$http.post('club_coach/createCoach',_this.coach).then(function(res){
                // console.log(res)
                if(res.data.code == 0){
                    // Toast('您的资料已经提交，请等待审核')
                    _this.step = 1
                }else{
                    Toast(res.data.message)
                }
            })
        },
        getArea: function(area){
            // 选择城市
            this.coach.province = area[0].code;
            this.coach.city = area[1].code;
            this.coach.county = area[2].code;
            this.coachAreaTips = area[0].name + '-' + area[1].name + '-' + area[2].name;
            this.areaPopupShow = false;
        },
        getTime: function(time){
            // 选择时间
            this.coach[this.timeField] = time.getFullYear() + '-' + (time.getMonth()+1) + '-' + time.getDate()
            this.tips[this.timeField] = this.coach[this.timeField]
            this.timePopupShow = false;
        },
        getIdCardUrl: function(url){
          // 身份证照片
            this.coach[url.name] = url.url;
        },
        getUploadedUrl: function(url){
            // console.log(url)
            // 上传组件上传完毕后展示处理
            this.tmp[url.name].push(url.url)
            this.tmpbase64[url.name].push(url.base64)
        },
        removeImg: function(name,index){
          // 删除已上传的照片
            this.tmp[name].splice(index,1)
            this.tmpbase64[name].splice(index,1)
        },
        closePage:function(){
            //关闭页面
            this.$router.push('/my')
        }
    }
}
</script>
<style lang="less" scoped>
.clear{
    overflow: hidden;
}
.coach-entry{
    h2{
        padding: .15rem;
        &.left{
            padding-left: 0;
        }
    }
    h4{
        margin-left: .15rem;
        &::before {
            content: '*';
            position: absolute;
            left: 0.07rem;
            font-size: 0.14rem;
            color: #f44;
        }
    }
    &__step{
        padding: .1rem .15rem;
    }
    &__description{
        padding: 0 .15rem;
        line-height: 2;
    }
    &__grid{
        width: 100%; height: 100%;
        &>iframe{
            height: 100%;
        }
    }
    &__checkbox{
        margin-left: .15rem;
        border-bottom: .01rem solid #f6f6f6;
        &-row{
            padding: .15rem .15rem 0 .15rem;
            margin-left: .15rem;
            overflow: hidden;
            &>.van-radio,&>.van-checkbox{
                float: left;
                margin-bottom:.15rem;
                width: 50%;
            }
            &>.van-radio{
                padding-top:.02rem;
            }
        }
    }
    .uploaded__box{
        position: relative;
        border: 0.01rem dashed #ddd;
        border-radius: 0.04rem;
        overflow: hidden;
        &>img{
            width: 100%;height: 100%;
            object-fit: cover;
        }
        &--del{
            position: absolute;
            display: block;
            width: .6rem; line-height: .3rem;
            color: white;
            background-color: red;
            right: 0; bottom: 0;
            border-radius: 0;
        }
    }
}
// 申请成功
.bind_result_page {
  padding-bottom: .2rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 2;
  .success-content {
    &_icon {
      height: 1.2rem;
      line-height: 1.5rem;      
      & i{
          font-size: .8rem;
      }
    }
    &_qrcode {
      width: 205px;
      height: 205px;
      margin: .1rem auto;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .fail-content {
    padding-bottom: 200px;
    &_icon {
      color: lighten(#EC284D, 10%);
      font-size: 100px;
    }
    &_subtitle {
      padding: 0 30px;
    }
  }
  .sureBtn{
      height: .4rem;
      line-height: .4rem;
      border-radius: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/CoachEntry.vue